import React, { useEffect } from 'react'
import SubNav from '../../../Shared/SubNav'
import { useLocation, useNavigate } from 'react-router-dom';
import socket from '../../../context/socket';

export const CustomizedActionPlan = () => {
    const navigate = useNavigate();
    const roomId = new URLSearchParams(useLocation().search).get("clientId");
    

    useEffect(() => {
      socket.emit("join", roomId);
    }, [roomId]);

    const handleNext = () => {
      const nextUrl = `/capital-gain-report?clientId=${roomId}`;
      socket.emit("navigate", { room: roomId, url: nextUrl });
      navigate(nextUrl);
    };
  
    const handleBack = () => {
      const prevUrl = `/portfolio-review?clientId=${roomId}`;
      socket.emit("navigate", { room: roomId, url: prevUrl });
      navigate(prevUrl);
    };
  return (
    <>
        <div className="container">
            <div className="row  pb-2">
                <div className="col text-center">
                    <p className="clrgreen" style={{fontSize:" 28px!important"}}>Here's Your Customized Action Plan</p>
                </div>
            </div>
            <div className="row rowwidth mx-auto w-75" >
                <div className="col">
                    <div className="card border-0">
                        <img src="assets/images/key.png" className="w-100" alt="..."/>
                        <div className="card-body border border-1">
                            <form>
                                <label>
                                    <input type="checkbox" name="languages" value="HTML"/>
                                    <span>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quas tempore
                                        voluptate quos veritatis fugiat excepturi expedita..
                                    </span>
                                </label>
                                <br/>
                                <label>
                                    <input type="checkbox" name="languages" value="HTML"/>
                                    <span>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quas tempore
                                        voluptate quos veritatis fugiat excepturi expedita..
                                    </span>
                                </label>
                                <br/>
                                <label>
                                    <input type="checkbox" name="languages" value="HTML"/>
                                    <span>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quas tempore
                                        voluptate quos veritatis fugiat excepturi expedita..
                                    </span>
                                </label>
                                <br/>
                                <label>
                                    <input type="checkbox" name="languages" value="HTML"/>
                                    <span>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quas tempore
                                        voluptate quos veritatis fugiat excepturi expedita..
                                    </span>
                                </label>
                            </form>
                            {/* <!-- <a href="#" className="btn btn-primary">Go somewhere</a> --> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-4 mb-3">
                <div className="col text-center">
                    <span>
                        <button className="btndesign pt-1 border border-1" fdprocessedid="ulfopb">Next
                            <img src="assets/images/wrong.png" alt=""/>
                        </button>
                    </span>
                    {/* <!-- Modal For Submit button here--> */}
                    <span>
                        <button className="btnactive clr active pt-1 text-white mx-2" fdprocessedid="xlfr9f"
                           data-bs-toggle="modal" data-bs-target="#exampleModal">Back
                            <img src="assets/images/right.png" alt=""/>
                        </button>
                    </span>
                </div>
            </div>
        </div>

        <div className="row mt-md-3 mt-4">
        <div className="col">
          <div className="container">
            <div className="row my-4">
              <div className="col text-end">
                <a href="javascript:void(0);" onClick={handleBack}>
                  <img
                    className="arrow_next1"
                    src="assets/images/left-arrowpng.png"
                    alt=""
                  />
                </a>
                <a href="javascript:void(0);" className="ms-1" onClick={handleNext}>
                  <img
                    className="arrow_next"
                    src="assets/images/right-arrow.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
